module.exports = __webpack_public_path__ + "MyNBN_icon.png?ce96602336199e0869665b917d4e0183";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/MyNBN_icon.png
// module id = 220
// module chunks = 0